// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dict from "common/src/util/Dict.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as TbAugmentsModal11 from "../team-planner11/TbAugmentsModal11.bs.js";
import * as Belt_MutableMapInt from "rescript/lib/es6/belt_MutableMapInt.js";

function TbComponentsSection17(Props) {
  var items = Props.items;
  var augments = Props.augments;
  var setAugments = Props.setAugments;
  var commonT = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return false;
      });
  var setModalOpen = match[1];
  React.useState(function () {
        return false;
      });
  ScreenAtom.use(undefined);
  var componentCounts = Belt_MutableMapInt.make(undefined);
  Belt_Array.forEach(Belt_Array.concatMany(Belt_Array.map(items, (function (i) {
                  return Belt_Option.mapWithDefault(Dict.get(Data13.items, i), [], (function (i) {
                                return i.from;
                              }));
                }))), (function (c) {
          var curr = Belt_Option.getWithDefault(Belt_MutableMapInt.get(componentCounts, c), 0);
          return Belt_MutableMapInt.set(componentCounts, c, curr + 1 | 0);
        }));
  var onSelectAugment = React.useCallback((function (augId) {
          Curry._1(setAugments, (function (augs) {
                  return Belt_Array.concat(augs, [augId]);
                }));
          return Curry._1(setModalOpen, (function (param) {
                        return false;
                      }));
        }), []);
  return React.createElement(React.Fragment, undefined, React.createElement(ContentSection.make, {
                  className: "mt-4 min-h-[120px]",
                  children: null,
                  noPadding: true
                }, Belt_MutableMapInt.size(componentCounts) > 6 ? null : React.createElement("div", {
                        className: "pt-4 px-4 flex space-between relative leading-none justify-center"
                      }, React.createElement("div", {
                            className: "font-medium"
                          }, commonT("Components"))), React.createElement("div", {
                      className: "p-4 pt-3 grid gap-[6px] grid-cols-[repeat(auto-fill,26px)]"
                    }, Belt_Array.map(Belt_MutableMapInt.toArray(componentCounts), (function (param) {
                            var match = Belt_Array.getExn(Data13.itemsArr(), param[0] - 1 | 0);
                            var itemId = match[0];
                            return React.createElement("div", {
                                        key: itemId,
                                        className: "relative"
                                      }, React.createElement(ItemImage.make, {
                                            itemId: itemId,
                                            size: 26
                                          }), React.createElement("div", {
                                            className: "absolute font-medium text-sm leading-none right-[1px] bottom-[1px] text-shadow-strong"
                                          }, "x" + String(param[1])));
                          })))), React.createElement(TbAugmentsModal11.make, {
                  modalOpen: match[0],
                  setModalOpen: setModalOpen,
                  augments: augments,
                  onSelectAugment: onSelectAugment
                }));
}

var make = TbComponentsSection17;

export {
  make ,
  
}
/* react Not a pure module */
